<template>
  <div class="filters-row">
    <div><base-select searchable :loading="filters.specialty.loading" :options="filters.specialty.options" @input="specialtySelected" valueProp="id" :label="$i18nHelpers.normalizeProp('name')" v-model="filters.specialty.value" :placeholder="filters.specialty.placeholder"></base-select></div>
    <!-- <label @click="showSpecialtyNotFound = true" class="specialty-advice" v-html="$t('filters.specialityNotFoundCompanies')"></label> -->
    <hr>
    <div v-if="filters.appointmentType.options.length > 0">
      <div><base-select :loading="filters.appointmentType.loading" clearable :options="filters.appointmentType.options" avoidDefaultSort valueProp="id" :label="$i18nHelpers.normalizeProp('name')" v-model="filters.appointmentType.value" :placeholder="filters.appointmentType.placeholder"></base-select></div>
      <hr>
    </div>
    <div><base-select searchable clearable :loading="filters.language.loading" :options="filters.language.options" valueProp="id" label="name" v-model="filters.language.value" :placeholder="filters.language.placeholder"></base-select></div>
    <div v-if="copaymentEnabled">
      <hr>
      <div><base-input zeroMarginBottom v-model="filters.coupon.value" :placeholder="filters.coupon.placeholder"></base-input></div>
    </div>
    <div class="text-center mt-3">
        <span cols="6" @click="removeFilters"><b-icon-x-circle class="red pointer"></b-icon-x-circle> <span class="pointer" v-html="$t('filters.removeFilters')"></span></span>
    </div>
    <div class="text-center mt-4 mb-5"><base-button @click="search" class="w-100">{{$t('filters.showResults')}}</base-button></div>
    <base-dialog v-model="showSpecialtyNotFound" :content="$t('specialtyNotFoundAdvice')" :okBtnText="$t('continue')" :okFn="goToSearch" :cancelBtnText="$t('cancel')" :cancelFn="() => { showSpecialtyNotFound = false }"></base-dialog>
  </div>
</template>

<script>
import companiesRepository from '@/repositories/CompaniesRepository'
import { GP_SPECIALTY_ID, GP_FAMILY_SPECIALTY_ID, PSYCHOLOGY_SPECIALTY_ID, CLINIC_PSYCHOLOGY_SPECIALTY_ID } from '@/constants/db/specialties'
import { VIDEO, INPLACE, WRITTEN, SECOND_OPINION, IMMEDIATE_VIDEO, AT_HOME, CHAT, CALL, INSURANCE } from '@/constants/consultationTypes'
import BaseDialog from '@/components/base/BaseDialog.vue'
import { SCREEN_LG_GRID } from '@/constants/mediaQueries'

export default {
  components: {
    BaseDialog
  },
  props: {
    companiesServices: Object
  },
  data () {
    return {
      filters: {
        specialty: {
          loading: false,
          options: [],
          placeholder: this.$t('filters.speciality'),
          value: null
        },
        language: {
          loading: false,
          options: [],
          placeholder: this.$t('filters.language'),
          value: null
        },
        appointmentType: {
          loading: false,
          options: [],
          placeholder: this.$t('filters.consultationsType'),
          value: null,
          order: [INPLACE, VIDEO, WRITTEN, CHAT, SECOND_OPINION, IMMEDIATE_VIDEO, AT_HOME, INSURANCE, CALL]
        },
        coupon: {
          placeholder: this.$t('filters.coupon'),
          value: null
        }
      },
      showSpecialtyNotFound: false
    }
  },
  created () {
    if (Object.keys(this.$route.query).length > 0) {
      this.filters.specialty.value = parseInt(this.$route.query.specialty) || null
      this.search()
      this.loadAppointmentTypes()
      // window.history.replaceState(null, '', window.location.pathname)
    }
    this.loadSpecialties()
    this.loadLanguages()
  },
  computed: {
    copaymentEnabled () {
        return this.filters.specialty.options.some(item => item.id === this.filters.specialty.value && item.copaymentEnabled)
    },
    mobileVersion () {
      return window.innerWidth < SCREEN_LG_GRID
    }
  },
  methods: {
    goToSearch () {
      location.href = this.$helpers.getV2AppUrl('patient/search')
    },
    specialtySelected () {
        this.loadAppointmentTypes()
        this.loadLanguages()
    },
    loadSpecialties () {
      companiesRepository.getSpecialtiesInfo().then(response => {
        this.filters.specialty.options = response.data
        // Delete gp family id specialty if GP is included
        if ([GP_SPECIALTY_ID, GP_FAMILY_SPECIALTY_ID].every(id => this.filters.specialty.options.some(specialty => specialty.id === id))) {
            this.filters.specialty.options = this.filters.specialty.options.filter(specialty => specialty.id !== GP_FAMILY_SPECIALTY_ID)
        }
        // Delete clinical psychology id specialty if psychology is included
        if ([PSYCHOLOGY_SPECIALTY_ID, CLINIC_PSYCHOLOGY_SPECIALTY_ID].every(id => this.filters.specialty.options.some(specialty => specialty.id === id))) {
            this.filters.specialty.options = this.filters.specialty.options.filter(specialty => specialty.id !== CLINIC_PSYCHOLOGY_SPECIALTY_ID)
        }
      })
    },
    loadLanguages () {
      companiesRepository.getLanguages(this.filters.specialty.value).then(response => {
          this.filters.language.options = response.data
      })
    },
    loadAppointmentTypes () {
        companiesRepository.getConsultationTypes(this.filters.specialty.value).then(response => {
            this.filters.appointmentType.options = response.data
        })
    },
    search () {
      let params = {}
      if (!this.filters.specialty.value) {
        this.$store.dispatch('showInfoAlert', this.$t('filters.selectSpecialty'))
      } else {
        Object.keys(this.filters).forEach(key => { params[key] = this.filters[key].value })
        this.$emit('search', params)
      }
    },
    removeFilters () {
      Object.keys(this.filters).forEach(key => { this.filters[key].value = this.filters[key].defaultValue ? this.filters[key].defaultValue : null })
    }
  }
}
</script>

<style lang="scss" scoped>
.filters-row{
  hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}
.red {
  color: $red;
}
.blue {
  color: $blue;
}
.specialty-advice{
  margin-top: 0.5rem;
  font-weight: bold;
  font-size: 0.8rem;
  cursor: pointer;
}
.pointer{
    cursor: pointer;
}
/deep/ .no-border-right{
  input{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
/deep/ .no-border-left{
  input{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/search/companies/SearchCompaniesFilters.vue